import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
@Injectable({
    providedIn: 'root',
})
export class SubscribeService {
    constructor(private http: HttpClient) {}

    subscribeToList(email: string, tags?: string[]) {
        let key = 'sewnstaging-outlet',
            audienceId = 'd1cee4f747';
        if (!environment.needProtect) {
            key = 'eraofwe-outlet';
            audienceId = 'f4f7c2427a';
        }

        const mailChimpEndpoint = `https://nordsud.us6.list-manage.com/subscribe/post-json?u=e93a215496f5c5f6203911365&amp;id=${audienceId}`;

        let params: any;
        if (tags?.length > 0) {
            params = new HttpParams().set('EMAIL', email).set('MERGE6', key).set('tags', tags.join(','));
        } else {
            params = new HttpParams().set('EMAIL', email).set('MERGE6', key);
        }
        const mailChimpUrl = mailChimpEndpoint + '&' + params.toString();
        return this.http.jsonp(mailChimpUrl, 'c');
    }
}
